/**
 * Input Validation Utility
 * Handles validation and sanitization of user inputs
 */

/**
 * Validates and sanitizes weight input for the price calculator
 * - Filters out non-numeric characters (except decimal point)
 * - Allows only digits and a single decimal point
 * - Limits to 2 decimal places
 * 
 * @param value - Raw input string from user
 * @returns Sanitized string containing only valid numeric characters
 * 
 * @example
 * validateWeightInput('123.45') // Returns '123.45'
 * validateWeightInput('abc123.45xyz') // Returns '123.45'
 * validateWeightInput('12.34.56') // Returns '12.34'
 * validateWeightInput('12.345') // Returns '12.34'
 */
export function validateWeightInput(value: string): string {
  // Remove all non-numeric characters except decimal point
  let cleaned = value.replace(/[^\d.]/g, '');

  // Ensure only one decimal point
  const parts = cleaned.split('.');
  if (parts.length > 2) {
    // Multiple decimal points found - keep first one and merge rest
    cleaned = parts[0] + '.' + parts.slice(1).join('');
    
    // Re-split after merging to check decimal places
    const newParts = cleaned.split('.');
    if (newParts.length === 2 && newParts[1].length > 2) {
      cleaned = newParts[0] + '.' + newParts[1].substring(0, 2);
    }
  } else if (parts.length === 2 && parts[1].length > 2) {
    // Limit to 2 decimal places
    cleaned = parts[0] + '.' + parts[1].substring(0, 2);
  }

  return cleaned;
}
